declare let google: any;

import { Directive, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GooglePlacesAddress, GooglePlacesAddressType } from '../../core/models';

/**
 * Provides Google Places Autocomplete help while you are typing and fills the data when you click on a result.
 */
@Directive({
  selector: '[appGooglePlaces]'
})
export class GooglePlacesDirective implements OnInit {
  @Input() public appGooglePlaces: any;
  @Output() public onAddressSelect: EventEmitter<GooglePlacesAddress> = new EventEmitter<GooglePlacesAddress>();

  constructor(public elRef: ElementRef) { }

  public ngOnInit(): void {
    const autocomplete = new google.maps.places.Autocomplete(this.elRef.nativeElement);
    autocomplete.setFields(['address_component']);

    autocomplete.addListener('place_changed', () => {
      this.onAddressSelect.emit(
        this.composeAddress(autocomplete.getPlace())
      );
    });
  }

  /**
   * Create GooglePlacesAddress object to be passed to components that use Google Places Autocomplete.
   */
  private composeAddress(places: google.maps.places.PlaceResult): GooglePlacesAddress {
    const googlePlacesAddress = new GooglePlacesAddress();
    let street: string = null;
    let streetNumber: string = null;

    places.address_components.forEach((place: any) => {
      place.types.forEach((type: any) => {
        if (type === GooglePlacesAddressType.StreetNumber) {
          streetNumber = place.long_name;
        }

        if (type === GooglePlacesAddressType.StreetName) {
          street = place.long_name;
        }

        if (type === GooglePlacesAddressType.City) {
          googlePlacesAddress.setCity = place.long_name;
        } else if (type === GooglePlacesAddressType.PostalCity && googlePlacesAddress.getCity === '') {
          googlePlacesAddress.setCity = place.long_name;
        }

        if (type === GooglePlacesAddressType.PostalCode) {
          googlePlacesAddress.setPostalCode = place.long_name;
        }

        if (type === GooglePlacesAddressType.Country) {
          googlePlacesAddress.setCountry = place.short_name;
        }
      });
    });

    googlePlacesAddress.setStreet = {street, streetNumber};

    return googlePlacesAddress;
  }
}
